const zh_CN = {
  layout: {
    cos_button: {
      phone: '電話',
      update_phone_number_message: '電話號碼已成功更新！'
    },
    time: {
      days: '天',
      hours: '小時',
      mins: '分鐘',
      secs: '秒',
      starts: '開始',
      starts_immediately: '立即開始'
    },
    field: {
      host: '主持人'
    },
    copy: '複製'
  },
  validations: {
    email: '必須是有效的電子郵件',
    phone: '必須是有效的電話號碼',
    required_field: '為必填欄位'
  },
  mailer: {
    need_help: '需要幫助？',
    stop_reminders: '停止接收提醒',
    cancel_registration: '取消註冊',
    report_abuse: '举报滥用行为'
  },
  datetime: {
    no_sessions: '暫無可用場次',
    empty_label: '日期/時間'
  },
  errors: {
    verification_failed: '验证失败，请重试。',
    session_unavailable: '您選擇的時間已不再可用，請選擇其他場次。',
    challenge_email_mismatch: '請使用您報名活動時所用的同一電子郵件進行報名。'
  }
}

export default zh_CN
